module.exports = __webpack_public_path__ + "img/incubator-3.bde30604.jpg";